<template>
  <v-dialog v-model="show" persistent max-width="848" :minHeight="minHeight">
    <v-card class="wrapper">
      <v-toolbar dense>
        <v-icon small>{{ icon }}</v-icon>
        <p class="title">{{ title }}</p>
        <v-spacer></v-spacer>
        <v-btn small icon @click="close">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container class="contents">
        <vue-scrollbar :style="scrollHeight">
          <component v-bind:is="component" :value="show" />
        </vue-scrollbar>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import VDialog from '../../components/dialog/VDialog';

export default {
  components: {
    VDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    component: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      default: 'mdi-desktop-mac',
    },
    title: {
      type: String,
    },
    contentHeight: {
      type: Number,
      default: 600,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  computed: {
    scrollHeight() {
      return `height: ${this.contentHeight}px`;
    },
    minHeight() {
      return this.contentHeight - 100;
    },
  },
};
</script>

<style scoped>
.wrapper {
  overflow: hidden;
}
.title {
  margin: 0 0 0 10px;
}
.contents {
  max-height: 624px;
}
</style>
